(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jobsaver-x1-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jobsaver-x1')) {
  customElements.define('jobsaver-x1', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const listen = (el, type, fn, options = {}) => el?.addEventListener(type, fn, { ...options, signal: this.abort.signal });
      let config;
      try { config = JSON.parse(this.querySelector('[data-x1-config]').textContent); } catch { return; }
      const form = this.querySelector('form.x1-form');
      const master = this.querySelector('[data-master]');
      const options = [...this.querySelectorAll('[data-option]')];
      const add = this.querySelector('[data-add]');
      const status = this.querySelector('[data-status]');
      const range = this.querySelector('[data-savings-range]');
      const addon = this.querySelector('[data-addon]');
      const addonWrap = this.querySelector('[data-addon-wrap]');
      const addonTotal = this.querySelector('[data-addon-total]');
      let submitting = false;
      const totalMoney = new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'USD' });
      const updateAddonTotal = () => {
        const hasUpgrade = Boolean(addon?.checked && !addon.disabled);
        const total = selected ? selected.price + (hasUpgrade ? Number(config.addonPrice || 0) : 0) : 0;
        const formattedTotal = selected ? totalMoney.format(total / 100) : '—';
        if (addonTotal) {
          addonTotal.hidden = !hasUpgrade || !selected;
          addonTotal.textContent = selected && hasUpgrade ? `Total with wheel pack: ${formattedTotal}` : '';
        }
        if (add && !submitting) {
          add.textContent = selected?.available ? `${config.strings.add} — ${formattedTotal}` : (selected ? config.strings.soldOut : config.strings.unavailable);
        }
      };
      if (addonWrap) addonWrap.hidden = false;
      listen(addon, 'change', updateAddonTotal);
      let selected = config.variants.find(v => String(v.id) === master?.value);
      let money;
      try { money = new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'USD', maximumFractionDigits: 0 }); }
      catch { money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }); }
      const recalculate = () => {
        const monthly = Number(range.value);
        this.querySelector('[data-savings-label]').textContent = money.format(monthly);
        this.querySelector('[data-payback]').textContent = selected ? (selected.price / 100 / monthly).toLocaleString(config.locale || 'en', { maximumFractionDigits: 1, minimumFractionDigits: 1 }) : '—';
      };
      const slides = [...this.querySelectorAll('[data-slide]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      let active = Math.max(0, slides.findIndex(s => !s.hidden));
      const activate = index => {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          if (i !== active) {
            slide.querySelectorAll('video').forEach(video => video.pause());
            slide.querySelectorAll('iframe').forEach(frame => { if (!slide.hidden) frame.src = frame.src; });
          }
          slide.hidden = i !== active;
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === active)));
        const thumb = thumbs[active];
        if (thumb) thumb.parentElement.scrollTo({ left: Math.max(0, thumb.offsetLeft - thumb.parentElement.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2), behavior: 'auto' });
      };
      thumbs.forEach((thumb, i) => listen(thumb, 'click', () => activate(i)));
      listen(this.querySelector('[data-prev]'), 'click', () => activate(active - 1));
      listen(this.querySelector('[data-next]'), 'click', () => activate(active + 1));
      listen(this.querySelector('[data-gallery]'), 'keydown', e => {
        if (!e.target.matches('[data-zoom],[data-prev],[data-next]')) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); activate(active + (e.key === 'ArrowRight' ? 1 : -1)); slides[active].querySelector('[data-zoom]')?.focus(); }
      });
      const update = (fromOptions, updateUrl = true) => {
        selected = fromOptions && options.length ? config.variants.find(v => v.options.every((value, i) => value === options[i]?.value)) : config.variants.find(v => String(v.id) === master.value);
        if (!selected) {
          master.value = '';
          add.disabled = true;
          add.textContent = config.strings.unavailable;
          status.textContent = config.strings.unavailable;
          this.querySelectorAll('[data-price]').forEach(el => { el.textContent = '—'; });
          this.querySelector('[data-compare]').hidden = true;
        } else {
          master.value = String(selected.id);
          options.forEach((option, i) => { option.value = selected.options[i]; });
          this.querySelectorAll('[data-price]').forEach(el => { el.textContent = selected.formatted; });
          const compare = this.querySelector('[data-compare]');
          compare.hidden = !(selected.compare > selected.price);
          compare.textContent = selected.formattedCompare;
          add.disabled = !selected.available;
          add.textContent = selected.available ? `${config.strings.add} — ${selected.formatted}` : config.strings.soldOut;
          status.textContent = selected.available ? `${selected.options.join(' / ')} — ${selected.formatted}` : config.strings.soldOut;
          if (selected.mediaId) {
            const index = slides.findIndex(slide => slide.dataset.mediaId === String(selected.mediaId));
            if (index >= 0) activate(index);
          }
        }
        if (updateUrl) {
          const url = new URL(location.href);
          if (selected) url.searchParams.set('variant', String(selected.id)); else url.searchParams.delete('variant');
          history.replaceState(history.state, '', url);
        }
        master.dispatchEvent(new Event('change', { bubbles: true }));
        recalculate();
        updateAddonTotal();
      };
      options.forEach(option => listen(option, 'change', () => update(true)));
      if (master && form) {
        this.querySelector('[data-native-picker]').hidden = true;
        this.querySelector('[data-enhanced-picker]').hidden = false;
        update(false, false);
        listen(form, 'submit', async e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (submitting) return;
          status.removeAttribute('data-error');
          if (!selected?.available || master.value !== String(selected.id)) {
            status.setAttribute('data-error', '');
            status.textContent = config.strings.unavailable;
            return;
          }
          const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
          const items = [{ id: selected.id, quantity }];
          if (addon?.checked && !addon.disabled) items.push({ id: Number(addon.dataset.variantId), quantity });
          submitting = true;
          add.disabled = true;
          add.textContent = 'Adding…';
          status.textContent = 'Adding your selection to the cart…';
          form.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(config.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'Unable to add your selection. Please try again.');
            status.textContent = 'Added to cart.';
            window.location.assign(config.cartUrl);
          } catch (error) {
            status.setAttribute('data-error', '');
            status.textContent = error.message || 'Unable to confirm the cart update. Please check your cart before trying again.';
          } finally {
            submitting = false;
            form.removeAttribute('aria-busy');
            add.disabled = !selected?.available;
            updateAddonTotal();
          }
        }, { capture: true });
      }
      listen(window, 'popstate', () => {
        const variantId = new URL(location.href).searchParams.get('variant');
        if (variantId && config.variants.some(v => String(v.id) === variantId)) { master.value = variantId; update(false, false); }
      });
      listen(range, 'input', recalculate);
      const dialog = this.querySelector('[data-lightbox]');
      const enlarged = this.querySelector('[data-lightbox-image]');
      this.querySelectorAll('[data-zoom]').forEach(button => listen(button, 'click', () => {
        enlarged.src = button.dataset.src;
        enlarged.alt = button.querySelector('img')?.alt || '';
        dialog.showModal();
      }));
      listen(this.querySelector('[data-close]'), 'click', () => dialog.close());
      listen(dialog, 'click', e => { if (e.target === dialog) { const rect = dialog.getBoundingClientRect(); if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close(); } });
      this.querySelectorAll('video').forEach(video => listen(video, 'play', () => this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); })));
      const sticky = this.querySelector('[data-sticky]');
      const buy = this.querySelector('.x1-buybox');
      const refreshSticky = () => {
        this.frame = null;
        if (!sticky) return;
        sticky.hidden = buy.getBoundingClientRect().bottom >= 0 || this.getBoundingClientRect().bottom <= 90 || window.innerWidth > 749;
      };
      const scheduleSticky = () => { if (!this.frame) this.frame = requestAnimationFrame(refreshSticky); };
      listen(window, 'scroll', scheduleSticky, { passive: true });
      listen(window, 'resize', scheduleSticky);
      refreshSticky();
      listen(this, 'click', e => {
        const link = e.target.closest('a[href^="#X1"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.querySelector('[data-lightbox]')?.close();
      this.initialized = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jobsaver-x2-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jobsaver-x2')) {
  customElements.define('jobsaver-x2', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();

      const listen = (el, type, fn, options = {}) =>
        el?.addEventListener(type, fn, {
          ...options,
          signal: this.abort.signal
        });

      let config;

      try {
        config = JSON.parse(this.querySelector('[data-x2-config]').textContent);
      } catch {
        return;
      }

      const form = this.querySelector('form.x2-form');
      const master = this.querySelector('[data-master]');
      const options = [...this.querySelectorAll('[data-option]')];
      const add = this.querySelector('[data-add]');
      const status = this.querySelector('[data-status]');
      const range = this.querySelector('[data-savings-range]');

      let selected = config.variants.find(v => String(v.id) === master?.value);
      let money;

      try {
        money = new Intl.NumberFormat(config.locale || 'en', {
          style: 'currency',
          currency: config.currency || 'USD',
          maximumFractionDigits: 0
        });
      } catch {
        money = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0
        });
      }

      const recalculate = () => {
        const monthly = Number(range.value);

        this.querySelector('[data-savings-label]').textContent =
          money.format(monthly);

        this.querySelector('[data-payback]').textContent = selected
          ? (selected.price / 100 / monthly).toLocaleString(
              config.locale || 'en',
              {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
              }
            )
          : '—';
      };

      const slides = [...this.querySelectorAll('[data-slide]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];

      let active = Math.max(0, slides.findIndex(s => !s.hidden));

      const activate = index => {
        if (!slides.length) return;

        active = (index + slides.length) % slides.length;

        slides.forEach((slide, i) => {
          if (i !== active) {
            slide.querySelectorAll('video').forEach(video => video.pause());

            slide.querySelectorAll('iframe').forEach(frame => {
              if (!slide.hidden) frame.src = frame.src;
            });
          }

          slide.hidden = i !== active;
        });

        thumbs.forEach((thumb, i) =>
          thumb.setAttribute('aria-current', String(i === active))
        );

        const thumb = thumbs[active];

        if (thumb) {
          thumb.parentElement.scrollTo({
            left: Math.max(
              0,
              thumb.offsetLeft -
                thumb.parentElement.offsetLeft -
                thumb.parentElement.clientWidth / 2 +
                thumb.clientWidth / 2
            ),
            behavior: 'auto'
          });
        }
      };

      thumbs.forEach((thumb, i) =>
        listen(thumb, 'click', () => activate(i))
      );

      listen(this.querySelector('[data-prev]'), 'click', () =>
        activate(active - 1)
      );

      listen(this.querySelector('[data-next]'), 'click', () =>
        activate(active + 1)
      );

      listen(this.querySelector('[data-gallery]'), 'keydown', e => {
        if (!e.target.matches('[data-zoom],[data-prev],[data-next]')) return;

        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          activate(active + (e.key === 'ArrowRight' ? 1 : -1));
          slides[active].querySelector('[data-zoom]')?.focus();
        }
      });

      const update = (fromOptions, updateUrl = true) => {
        selected = fromOptions && options.length
          ? config.variants.find(v =>
              v.options.every((value, i) => value === options[i]?.value)
            )
          : config.variants.find(v => String(v.id) === master.value);

        if (!selected) {
          master.value = '';
          add.disabled = true;
          add.textContent = config.strings.unavailable;
          status.textContent = config.strings.unavailable;

          this.querySelectorAll('[data-price]').forEach(el => {
            el.textContent = '—';
          });

          this.querySelector('[data-compare]').hidden = true;
        } else {
          master.value = String(selected.id);

          options.forEach((option, i) => {
            option.value = selected.options[i];
          });

          this.querySelectorAll('[data-price]').forEach(el => {
            el.textContent = selected.formatted;
          });

          const compare = this.querySelector('[data-compare]');

          compare.hidden = !(selected.compare > selected.price);
          compare.textContent = selected.formattedCompare;

          add.disabled = !selected.available;

          add.textContent = selected.available
            ? `${config.strings.add} — ${selected.formatted}`
            : config.strings.soldOut;

          status.textContent = selected.available
            ? `${selected.options.join(' / ')} — ${selected.formatted}`
            : config.strings.soldOut;

          if (selected.mediaId) {
            const index = slides.findIndex(
              slide => slide.dataset.mediaId === String(selected.mediaId)
            );

            if (index >= 0) activate(index);
          }
        }

        if (updateUrl) {
          const url = new URL(location.href);

          if (selected) {
            url.searchParams.set('variant', String(selected.id));
          } else {
            url.searchParams.delete('variant');
          }

          history.replaceState(history.state, '', url);
        }

        master.dispatchEvent(new Event('change', { bubbles: true }));
        recalculate();
      };

      options.forEach(option =>
        listen(option, 'change', () => update(true))
      );

      if (master && form) {
        this.querySelector('[data-native-picker]').hidden = true;
        this.querySelector('[data-enhanced-picker]').hidden = false;
        update(false, false);

        listen(form, 'submit', e => {
          if (
            !selected?.available ||
            master.value !== String(selected.id)
          ) {
            e.preventDefault();
            status.textContent = config.strings.unavailable;
          }
        });
      }

      listen(window, 'popstate', () => {
        const variantId = new URL(location.href).searchParams.get('variant');

        if (
          variantId &&
          config.variants.some(v => String(v.id) === variantId)
        ) {
          master.value = variantId;
          update(false, false);
        }
      });

      listen(range, 'input', recalculate);

      const dialog = this.querySelector('[data-lightbox]');
      const enlarged = this.querySelector('[data-lightbox-image]');

      this.querySelectorAll('[data-zoom]').forEach(button =>
        listen(button, 'click', () => {
          enlarged.src = button.dataset.src;
          enlarged.alt = button.querySelector('img')?.alt || '';
          dialog.showModal();
        })
      );

      listen(this.querySelector('[data-close]'), 'click', () =>
        dialog.close()
      );

      listen(dialog, 'click', e => {
        if (e.target === dialog) {
          const rect = dialog.getBoundingClientRect();

          if (
            e.clientX < rect.left ||
            e.clientX > rect.right ||
            e.clientY < rect.top ||
            e.clientY > rect.bottom
          ) {
            dialog.close();
          }
        }
      });

      this.querySelectorAll('video').forEach(video =>
        listen(video, 'play', () =>
          this.querySelectorAll('video').forEach(other => {
            if (other !== video) other.pause();
          })
        )
      );

      const sticky = this.querySelector('[data-sticky]');
      const buy = this.querySelector('.x2-buybox');

      const refreshSticky = () => {
        this.frame = null;
        if (!sticky) return;

        sticky.hidden =
          buy.getBoundingClientRect().bottom >= 0 ||
          this.getBoundingClientRect().bottom <= 90 ||
          window.innerWidth > 749;
      };

      const scheduleSticky = () => {
        if (!this.frame) {
          this.frame = requestAnimationFrame(refreshSticky);
        }
      };

      listen(window, 'scroll', scheduleSticky, { passive: true });
      listen(window, 'resize', scheduleSticky);
      refreshSticky();

      listen(this, 'click', e => {
        const link = e.target.closest('a[href^="#X2"]');
        if (!link) return;

        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;

        e.preventDefault();

        target.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'instant'
            : 'smooth',
          block: 'start'
        });

        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    }

    disconnectedCallback() {
      this.abort?.abort();

      if (this.frame) {
        cancelAnimationFrame(this.frame);
      }

      this.querySelector('[data-lightbox]')?.close();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
